<div class="client-workflow-status tp-dashboard customer-dasboard">
  <div class="toast-bar d-flex align-items-center gap-2 justify-content-start" *ngIf="!showQuestionnaire">
    <img src="../../../../images/info-Icon.svg" alt="info icon"> Your have a pending questionnaire, <a [routerLink]="['/tax-planning/questionnaire-response']" [queryParams]="{ customerQuestionnaires: true }" style="cursor: pointer; text-decoration: underline;">click here</a> to complete it.
  </div>    


  <div class="row card_layout mb-3">
    <div class="medium-12 columns p-0">
      <div class="payment-dashboard">
        <div class="expanded">
          <div class="column medium-12 p-0">
            <div class="row justify-content-between">
              <div class="column p-0" ng-show="hasGraphData && !showMessage">
                <span class="graph-title" style="position: relative;top: 5px;">{{pieChartGraphName}}</span>
              </div>
              <div class="column medium-5 pe-0">
                <div class="row">
                  <div class="column medium-6 pe-0" *ngIf="views.length>0">
                    <label>
                      <app-tpiq-select-dropdown [includeNone]="false" [setData]="views" [setPlaceHolder]="'Select Type'" [setSearchKey]="'name'" [setValueKey]="'name'" (onValueSelect)="setGraphType($event)" [setDefaultValue]="currentView"></app-tpiq-select-dropdown>
                    </label>
                  </div>
                  <div class="column medium-6 pe-0">
                    <label>
                      <app-tpiq-select-dropdown [includeNone]="false" [setData]="filterYears" [setPlaceHolder]="'Select year'" [setSearchKey]="'name'" [setValueKey]="'id'" (onValueSelect)="setYear($event)" [setDefaultValue]="yearFilter"></app-tpiq-select-dropdown>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column medium-12 mt-4 expanded charts-main card_layout rounded-0">
            <div *ngIf="hasGraphData && !showMessage  && hasTotalSavingsByStrategyData" style="min-width: 300px;height:400px;">
              <highcharts-chart [Highcharts]="Highcharts" [options]="groupedTotalTaxSavingsByStrategyChartOptions"
                                style="width: 100%; height: 400px; display: block"></highcharts-chart>
            </div>
            <div class="client-workflow-status" *ngIf="showMessage">
              <div class="row showMessage" style="">
                  <div class="small-12 medium-12 columns">
                      <span class="hint">No Data available.</span>
                  </div>
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="small-12 medium-12 columns px-0">
      <div class="card_layout mb-3">
        <span class="graph-title mb-2">Assigned ToDo’s</span>
        <app-tpiq-customer-dashboard-todos [selectedYear]="yearFilter"></app-tpiq-customer-dashboard-todos>
      </div>
    </div>
  </div>
</div>
